__turbopack_context__.v({
  "description": "style-module-scss-module__6Ucama__description",
  "title": "style-module-scss-module__6Ucama__title",
});
